<template>
   <div class="box">
      <div>{{this.src}}</div>
      <iframe :src="iframeSrc" style="width:100%;height:100%;frameborder:0; position:absolute; top:0; left0;"></iframe>
  </div>
</template>
<script>


export default {
  data() {
    return {
      title:"检测站欢迎您",
      iframeSrc: "https://www.qiche365.org.cn",
    };
  },
  created() {

  },
  mounted() {
    if(this.$route.query.src !== undefined && this.$route.query.src !== null){
      this.iframeSrc =  this.$route.query.src;
    }
  },
  props: [],
  methods: {
 
  },
  components: {
      
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/recallInfo.vue